import styled from "styled-components";

export const Styles = styled.div`
  background: var(--bg-item);
  color: var(--color-item);
  padding: 12px;
  border-radius: 8px;
  order: 1;
  flex: 1;

  .timeline-note-row {
    .ant-form-item {
      width: 100%;
      max-width: 100%;
    }
  }

  .container-item-field {
    display: flex;
    margin-bottom: 12px;
    gap: 16px;

    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;

      .item-icon {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 20px;
        margin-bottom: 12px;

        &.empty {
          height: 1px;
          margin-bottom: 0;
        }
      }

      .line {
        flex: 1;
        min-height: 24px;
        width: 2px;
        background: #595959;
      }
    }

    .item-label {
      color: var(--color-item);
      font-weight: 700;
      margin-top: 4px;
      margin-bottom: 0;
    }

    .item-label--timeline-time-incomplete {
      color: var(--color-item);
      font-weight: 700;
    }

    .ant-form-item:not(.timeline-attachments-form-item) {
      margin-bottom: 0;
      width: 112px;
      max-width: 100%;
    }

    .ant-form-item.timeline-attachments-form-item {
      width: auto;
      min-width: 0;
      flex: 1;
      max-width: 100%;
    }

    .timeline-text .ant-form-item {
      width: 220px;
    }

    .timeline-note-row & .ant-form-item {
      width: 100%;
    }

    & > div:not(.left) {
      min-width: 0;
      flex: 1;
    }
  }
`;
